import api from './client';

export const specialQuotaAdminAPI = {
  getPendingQuotas: async (params = {}) => {
    const response = await api.get("/admin/special-quotas", { params });
    return response.data;
  },

  approveQuota: async (id, payload) => {
    const response = await api.post(
      `/admin/special-quotas/${id}/approve-quota`,
      payload
    );
    return response.data;
  },

  rejectQuota: async (id, payload) => {
    const response = await api.post(
      `/admin/special-quotas/${id}/reject-quota`,
      payload
    );
    return response.data;
  },

  approveSelection: async (id, payload = {}) => {
    const response = await api.post(
      `/admin/special-quotas/${id}/approve-selection`,
      payload
    );
    return response.data;
  },

  rejectSelection: async (id, payload) => {
    const response = await api.post(
      `/admin/special-quotas/${id}/reject-selection`,
      payload
    );
    return response.data;
  },

  uploadReceipt: async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    const response = await api.post(
      "/admin/special-quotas/upload-receipt",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },

  updateQuota: async (id, payload) => {
    const response = await api.patch(`/admin/special-quotas/${id}`, payload);
    return response.data;
  },

  uploadSlip: async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    const response = await api.post(
      "/admin/special-quotas/upload-slip",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },
};

// Biodata Management API
